/**
 * LiveStatusDownBadge — the rail's report that the notifications stream has been down past its
 * grace period. Every status is unknown then, so it names no server and offers no Detach: the
 * fault is the stream's, not the servers'.
 */
import { Unplug } from 'lucide-react';
import type { ReactElement } from 'react';
import React from 'react';

import { NavRailBadge } from '@/components/occurra/NavRailBadge';
import { StatusTone } from '@/types/status';

const LABEL = 'Live status down';
const DETAIL = `${LABEL}: no connection to the cloud's status feed. Server and camera statuses ` +
    'may be out of date.';

interface Props {
    isLabelled: boolean;
    isRoomy?: boolean;
}

export const LiveStatusDownBadge = ({ isLabelled, isRoomy = false }: Props): ReactElement => (
    <NavRailBadge
        icon={Unplug}
        label={LABEL}
        detail={DETAIL}
        tone={StatusTone.Neutral}
        isLabelled={isLabelled}
        isRoomy={isRoomy}
    />
);
